export default __webpack_public_path__ + "static/media/transaction.28446830.svg";